export default __webpack_public_path__ + "static/media/img3.7d3900b7.png";